import store from "../store";
import router from "../router";
import ErrorService from "./ErrorService";
import BaseService from "./BaseService";
import Utils from "../helpers/utils";
import { fetch as fetchPolyfill } from "whatwg-fetch";

export default class TranslationService {
  constructor() {
 
  }



  async getTranslation(url,text){
    try {
      let data =   await this.performRequest(url);
      return data;

    } catch (error) {
        
    }
  }

  async getTextLanguage(url,text){
    try {
      let data =   await this.performRequest(url);
      return data;

    } catch (error) {
        
    }
  }


  async performRequest(url) {
    try {

        // Widget data returns tenant, local data.zip has it inside
        var tenant = store.state.userTenant;
        if (!tenant) tenant = store.state.appData.JoinChatData.TenantID;
        var encoded = store.state.appData.WidgetData.translationConfig.token;
        var user = '2006'; // legacy default
        if (store.state.userIP) {
          var up = atob(encoded).split(':');
          if (up.length == 2) {
            user = store.state.userIP;
            encoded = btoa(user + ':' + up[1]);
          }
        }
        let myHeaders = {
            'Authorization': "Basic "+ encoded,
            "X-TenantID": tenant,
            "X-UserID": user,
        };
        const response = await fetchPolyfill(url, {
            method: "GET",
            headers: myHeaders,
        });
        const result = await response.json();

        if(response.status == 200){
            return result;
        }
        else{
            throw result;
        }
    } catch (e) {
        if(store.state.appData.WidgetData.translationConfig.isShowAlerts){
            let msg = `${store.state.appData.WidgetData.translationConfig.errorLabel || 'Get Translation Error'}`
            ErrorService.displayAlert(`${msg} . ${e.message}`);
        }
        else{
            Utils.log.error(e);
        }
        throw new Error(e);
    }
  }

  



}